export enum EAdService {
    disabled = -1,
    adMobFree = 1,
    adMobPro = 2,
    adMobPlus = 3,
    adColony = 101
}